import axios from 'axios';
import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import apiUrl from '../../Environment/Api';
import { ToWords } from 'to-words';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import html2canvas from 'html2canvas';


function InvoicePrint() {
    const navigate = useNavigate();
    const printRef = useRef(false);
    const [pdfGenerated, setPdfGenerated] = useState(false);
    const { invoice_id } = useParams();
    const location = useLocation();

    useEffect(() => {
        const delay = 1000;
        let cleanupFunction;

        console.log('Working for Print');
        const printTimer = setTimeout(() => {
            if (!printRef.current) {
                window.onbeforeprint = function() {
                    document.title = `${invoice_id}`;
                };
                window.print();
                printRef.current = true;
            }
            else {
                navigate('/invoice');
            }
        }, delay);


        return () => {
            if (cleanupFunction) {
                cleanupFunction();
            }
        };
    }, [invoice_id, navigate, pdfGenerated]);



    const [invoiceData, setInvoiceDetails] = useState({});
    const [invoiceList, setInvoiceList] = useState([]);
    const [gettaxpercentage, settaxpercentage] = useState([]);

    const getdata = async () => {
        const id = invoice_id;

        try {
            const responseDetails = await axios.get(apiUrl + `/invoicedetails/${id}`);
            console.log("invoice details data", responseDetails.data);
            setInvoiceDetails(responseDetails.data);
        } catch (err) {
            console.log(err);
        }

        try {
            const responseList = await axios.get(apiUrl + `/invoicelist/${id}`);
            console.log("invoice list data", responseList.data);
            setInvoiceList(responseList.data);
            console.log("the tax percentage", responseList.data[0].tax)
            settaxpercentage(responseList.data[0].tax);

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        getdata();
        clientdetails();
    }, [invoice_id]);

    // to get client details ---------------
    const [ClientDetails, setClientDetails] = useState([]);
    const clientdetails = async () => {
        try {
            const response = await axios.get(apiUrl + "/clientdetails");
            if (response) {
                setClientDetails(response.data);
            }
        } catch (error) {
            console.error("Error fetching client details:", error);
        }
    };

    const [getclientaddress, setclientaddress] = useState('')
    const [getclientcountry, setclientcountry] = useState('')
    const [getclientName, setclientName] = useState('');
    const [getclientmobile, setclientmobile] = useState('');
    const [getmobilecode, setmobilecode] = useState('');

    useEffect(() => {
        if (ClientDetails.length > 0 && invoiceData[0]?.clientId) {
            const clientaddresscountryfilter = ClientDetails.filter((data) => data.id === invoiceData[0]?.clientId);
            console.log("filter data", clientaddresscountryfilter);

            if (clientaddresscountryfilter.length > 0) {
                setclientName(clientaddresscountryfilter[0].clientName);
                setclientaddress(clientaddresscountryfilter[0].address);
                setclientcountry(clientaddresscountryfilter[0].country);
                setclientmobile(clientaddresscountryfilter[0].mobile);
                setmobilecode(clientaddresscountryfilter[0].countrycode);
            }
        }
    }, [ClientDetails, invoiceData]);



    const fulltableData = [...(invoiceList || [])];

    // Calculate subtotal, tax, and net total
    const subtotal = fulltableData.reduce((acc, row) => acc + parseFloat(row.price), 0);
    const tax = fulltableData.reduce((acc, row) => acc + parseFloat(row.tax), 0);
    const netTotal = fulltableData.reduce((acc, row) => acc + parseFloat(row.totalAmount), 0);
    // Calculate total quantity, total price, total tax, and total amount
    let totalQuantity = 0;
    let totalPrice = 0;
    let totalTax = 0;
    let totalAmount = 0;
    let sub = 0;

    fulltableData.forEach(row => {
        totalQuantity += parseInt(row.quantity);
        totalPrice += parseFloat(row.price);
        totalTax += parseFloat(row.tax);
        totalAmount += (parseFloat(row.quantity) * parseFloat(row.price)) + parseFloat(row.tax * row.quantity * row.price / 100);
        sub += (parseFloat(row.quantity) * parseFloat(row.price))
    });


    const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
            currencyOptions: {
                name: getmobilecode === '91' ? 'Rupees' : 'Dollar',
                plural: getmobilecode === '91' ? 'Rupees' : 'Dollar',
                symbol: getmobilecode === '91' ? '₹' : '$',
                fractionalUnit: {
                    name: getmobilecode === '91' ? 'Paisa' : 'Cents',
                    plural: getmobilecode === '91' ? 'Paisa' : 'Cents',
                    symbol: '',
                },
            }
        }
    });

    console.log("invoiceData", invoiceData);
    console.log("totalTax", invoiceData[0]?.totalTax);

    let words = toWords.convert(totalAmount);

    const formatDate = (dateString) => {
        const options = { month: 'short', year: 'numeric' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-US', options);
        return formattedDate;
    };
    const formatDate1 = (dateString) => {
        if (!dateString || dateString === "Invalid Date") {
            return ""; // Return empty string for invalid or empty dates
        }

        const date = new Date(dateString);
        const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        }).replace(/\//g, '-'); // Replace slashes with hyphens

        return formattedDate;
    };




    return (

        <div id="invoice-content" className='background-color-bill' style={{
            width: "100%",
            margin: "0px",
            fontSize:"15px",
            backgroundColor: 'white'
        }}>
            <h3 className='text-center mb-1'>Invoice Bill</h3>
            <div>
                <div className='row mb-1'>
                    <div className='col-lg-6 col-md-6 col-sm-6 '>
                        <div className='row'>
                            <img className='logo-bill' src={window.location.origin + require('../../../assets/img/Admin/Logo.png')} />

                        </div>

                    </div>

                    <div className='col-lg-6 col-md-6 col-sm-6 mt-4'>
                        <div className='row'>
                            <div className='col-lg-8 col-md-8 col-sm-8 line-height-space3'>
                                <p className='invoice-list  text-end'><b>Invoice No</b></p>
                                <p className='invoice-list  text-end'><b>Invoice Date</b></p>
                                <p className='invoice-list  text-end'><b>Due Date</b></p>
                                <p className='invoice-list  text-end'><b>Balance Due</b></p>
                            </div>
                            <div className='col-lg-4 col-md-4 col-sm-4 line-height-space3'>
                                <p className='text-black'>:  {invoiceData[0]?.invoiceId}</p>
                                <p className='text-black'>:  {formatDate1(invoiceData[0]?.date)}</p>
                                <p className='text-black'>:  {formatDate1(invoiceData[0]?.dueDate)} </p>
                                <p className='text-black'>:  <b>${totalAmount.toFixed(2)}</b> </p>
                            </div>
                        </div>

                    </div>
                    <hr />
                </div>
                <div className='row'>
                    <div className='col-lg-4 col-md-4 col-sm-4'>
                        <div className=' row logo-row line line-height-space3 mt-1'>
                            <b className='text-black'><p>VAS Post Production</p></b>
                            <p className='text-black'><b><i class="fa-solid fa-user"></i> - Vasanthan. K</b></p>
                            <p className='text-black'><b><i class="fa-solid fa-phone"></i></b> - +91 7708024254</p>
                            <p className='text-black'><i class="fa-solid fa-house"></i> - 87, Kamarajar Nagar,</p>
                            <p className='text-black indent'>Dadagapatti,</p>
                            <p className='text-black indent'>Salam-6.</p>

                        </div>
                    </div>
                    <div className='col-lg-4 col-md-4 col-sm-4 '></div>
                    <div className='col-lg-4 col-md-4 col-sm-4 '>
                        <div className='row'>
                            <p className='text-black'><b>Bill to : </b></p>
                        </div>
                        <div className=' logo-row line line-height-space3'>
                            <p className='text-black'><b><i class="fa-solid fa-user"></i> - {getclientName}</b>,</p>
                            <p className='text-black'><i class="fa-solid fa-phone"></i> - +{getmobilecode} {getclientmobile},</p>
                            <h6 className='text-black'><i class="fa-solid fa-house"></i> - {getclientaddress},</h6>
                            <p className='text-black indent'>{getclientcountry},</p>


                        </div>
                    </div>
                </div>
                <div className='row m-1'>
                    <table className='table table-striped'>
                        <thead className='table-dark'>
                            <tr>
                                <th className='sno' scope="col">S No.</th>
                                <th className='datetable' scope="col">Date</th>
                                <th scope="col">Project</th>
                                <th scope="col">Type</th>
                                <th scope="col">Qty</th>
                                <th className='pricetableprint' scope="col">Price</th>
                                <th className='amounttableprint' scope="col">Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {fulltableData.map((row, index) => (
                                <tr key={index} className={index % 2 === 1 ? 'table-secondary' : ''}>
                                    <td className='text-center sno' scope="row">{index + 1}</td>
                                    <td className='datetable'>{formatDate1(row.date)}</td>
                                    <td>{row.projectName}</td>
                                    <td>{row.type}</td>
                                    <td>{row.quantity}</td>
                                    <td className='pricetableprint'>
                                        {(() => {
                                            const clientData = ClientDetails.find(client => client.id === row.clientId);

                                            if (clientData) {
                                                const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                                return (
                                                    <span>
                                                        {currencySymbol} {parseFloat(row.price).toFixed(2)}
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </td>
                                    {/* <td>${parseFloat(row.price).toFixed(2)}</td> */}
                                    <td className='amounttableprint'>
                                        {(() => {
                                            const clientData = ClientDetails.find(client => client.id === row.clientId);

                                            if (clientData) {
                                                const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                                return (
                                                    <span>
                                                        {currencySymbol} {((parseFloat(row.quantity) * parseFloat(row.price)).toFixed(2))}
                                                    </span>
                                                );
                                            }
                                            return null;
                                        })()}
                                    </td>
                                    {/* <td>${((parseFloat(row.quantity) * parseFloat(row.price)).toFixed(2))}</td> */}
                                </tr>
                            ))}
                            <tr>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td><b>Total</b></td>
                                {/* <td>
                                    {(() => {
                                        // Use the first row to get the clientId
                                        const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

                                        if (clientData) {
                                            const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                            return (
                                                <span>
                                                    {currencySymbol} {totalQuantity}
                                                </span>
                                            );
                                        }
                                        return null;
                                    })()}
                                </td> */}
                                <td>{totalQuantity}</td>
                                <td></td>
                                <td>
                                    {(() => {
                                        // Use the first row to get the clientId
                                        const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

                                        if (clientData) {
                                            const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                            return (
                                                <span>
                                                    {currencySymbol} {sub.toFixed(2)}
                                                </span>
                                            );
                                        }
                                        return null;
                                    })()}
                                </td>
                                {/* <td>${sub.toFixed(2)}</td> */}
                            </tr>
                        </tbody>
                    </table>


                </div>

                <br />
                <div className='row'>
                    <div className='col-lg-4 col-md-4 col-sm-4 '>

                        <p className='form-label notes-style'><b>Amount in Words : </b> </p>
                        <p className='notes-style text-black'>{words}</p>
                        <p className='form-label notes-style'><b>Notes</b> </p>
                        <p className='notes-style'>{invoiceData[0]?.notes}</p>
                    </div>

                    <div className='col-lg-8 col-md-8 col-sm-8 '>
                        <div className='row total-content'>
                            <div className='col-lg-7 col-md-7 col-sm-7 line-height-space3'>
                                <p className='invoice-list text-end'><b>Sub Total</b> </p>
                                <p className='invoice-list text-end'><b>Paypal Tax ({gettaxpercentage}%)</b></p>
                                <p className='invoice-list text-end'><b>Net Total</b></p>
                            </div>
                            <div className='col-lg-5 col-md-5 col-sm-5 line-height-space3'>
                                {/* <p className='text-black'>: ${sub.toFixed(2)}</p> */}
                                <p className='text-black'>:

                                    {(() => {
                                        // Use the first row to get the clientId
                                        const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

                                        if (clientData) {
                                            const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                            return (
                                                <span>
                                                    {currencySymbol} {sub.toFixed(2)}
                                                </span>
                                            );
                                        }
                                        return null;
                                    })()}

                                </p>
                                <p className='text-black'>:
                                    {(() => {
                                        // Use the first row to get the clientId
                                        const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

                                        if (clientData) {
                                            const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                            return (
                                                <span>
                                                    {currencySymbol} {parseFloat(invoiceData[0]?.totalTax).toFixed(2)}
                                                </span>
                                            );
                                        }
                                        return null;
                                    })()}


                                </p>
                                <b className='text-black'>:

                                    {(() => {
                                        // Use the first row to get the clientId
                                        const clientData = ClientDetails.find(client => client.id === fulltableData[0]?.clientId);

                                        if (clientData) {
                                            const currencySymbol = clientData.countrycode === '91' ? '₹' : '$';
                                            return (
                                                <span>
                                                    {currencySymbol} {totalAmount.toFixed(2)}
                                                </span>
                                            );
                                        }
                                        return null;
                                    })()}

                                </b>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default InvoicePrint;